export const changeMessage = (message, value) => {
  let messageVal = message.split("&s");
  return messageVal[0]+ value + messageVal[1]
};
